import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import customAxios from "../../customAxios";
import { UPDATE_DRIVER } from "../../routes";

const updateDriverByAdmin = async (formData: ICreateAndUpdateDriver) => {
  try {
    return (
      await customAxios.put(UPDATE_DRIVER, {
        ...formData,
        userId: formData._id,
        gender: formData.gender?.value,
        company: formData.company?._id,
        marital: formData.marital?.value,
        city: formData.city,
        province: formData.province,
        financialGroupSchool: formData?.financialGroupSchool,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_DRIVER: error });
    return false;
  }
};

export default updateDriverByAdmin;
